// utils/paypalSdkOptions.js
// ONE set of PayPal SDK options for the whole app.
//
// Every <PayPalScriptProvider> (App root, PayPalProvider, PayPalPayment,
// CreditWallet) must pass exactly this object. Different options mean a
// different SDK URL, and react-paypal-js then tears the loaded SDK down and
// loads another one — which destroys PayPal buttons already on screen
// ("zoid destroyed all components") and breaks the inline card fields
// ("Cannot read properties of undefined (reading 'fundingEligibility')").
export const PAYPAL_SDK_OPTIONS = Object.freeze({
  clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: 'AUD',
  intent: 'capture',
  locale: 'en_AU',
  // card-fields = inline card form (Advanced Card Processing)
  components: 'buttons,googlepay,card-fields',
  // applepay shows the Apple Pay button where eligible
  enableFunding: 'card,applepay',
  disableFunding: 'paylater,venmo',
});
